import {
  createBlocContext,
  createBlocProvider
} from "@kernel/frontend-react-app";
import { useContext } from "react";
import { StatsRepositoryBloc } from "./StatsRpositoryBloc";

export const StatsRepositoryContext = createBlocContext<StatsRepositoryBloc>();

export function useStatsRepositoryContext() {
  const ctx = useContext(StatsRepositoryContext);
  return ctx;
}

export const StatsRepositoryBlocProvider =
  createBlocProvider<StatsRepositoryBloc>(
    StatsRepositoryBloc.create(),
    StatsRepositoryContext
  );
